import { render, staticRenderFns } from "./SectionProducts.vue?vue&type=template&id=291382b9&scoped=true&"
import script from "./SectionProducts.vue?vue&type=script&lang=ts&"
export * from "./SectionProducts.vue?vue&type=script&lang=ts&"
import style0 from "./SectionProducts.vue?vue&type=style&index=0&id=291382b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291382b9",
  null
  
)

export default component.exports